import { useCallback } from 'react'
import isEmpty from 'lodash/isEmpty'
import { TSmartWayCarrierSchema } from 'transfix-form/forms/SmartWayCarrier/components/SmartWayCarrierModal/schema/SmartWayCarrierSchema'
import { IUseSmartWayCarrierSubmitter } from 'transfix-form/forms/SmartWayCarrier/types'
import { useGlobalToast } from 'transfix-ui/components/Toast/GlobalToast'
import { Maybe } from 'types/graphqlTypes'
import { useCarrierProfileQuery } from '../../../../Carrier/graphql/CarrierProfile'
import { TOAST_ERROR_MESSAGE } from '../../../constants'
import { useUpdateCarrierSmartWayRegistrationMutation } from '../graphql/UpdateCarrierSmartWayRegistrationMutation'

const TOAST_SUCCESS_MESSAGE = 'SmartWay Carrier preferences updated successfully'

export const useSmartWayCarrierSubmitter = (
  carrierApplicationId: string,
  smartWayRegistrationId?: Maybe<string>
): IUseSmartWayCarrierSubmitter<TSmartWayCarrierSchema> => {
  const { openToast } = useGlobalToast()

  const {
    loading: fetchCarrierProfileLoading,
    refetch: fetchCarrierProfile,
  } = useCarrierProfileQuery({
    skip: true,
    variables: {
      id: carrierApplicationId,
    },
  })
  const [
    updateSmartWayRegistration,
    { loading: updateSmartWayRegistrationLoading },
  ] = useUpdateCarrierSmartWayRegistrationMutation()

  const showErrorToast = useCallback(() => {
    openToast({ toastMessage: TOAST_ERROR_MESSAGE, toastType: 'alert' })
  }, [openToast])

  const submitHandler = useCallback(
    async ({ isRegistered, renewalDate }: TSmartWayCarrierSchema) => {
      const { data, errors: gqlErrors } = await updateSmartWayRegistration({
        variables: {
          input: {
            carrierApplicationId,
            isRegistered,
            renewalDate,
          },
        },
      })
      const { updateCarrierSmartWayRegistration } = data ?? {}
      const { errors: clientErrors } = updateCarrierSmartWayRegistration ?? {}

      if (isEmpty(gqlErrors) && isEmpty(clientErrors)) {
        if (!smartWayRegistrationId) {
          await fetchCarrierProfile()
        }
        openToast({ toastMessage: TOAST_SUCCESS_MESSAGE })
        return true
      }

      showErrorToast()
      return false
    },
    [
      carrierApplicationId,
      fetchCarrierProfile,
      openToast,
      showErrorToast,
      smartWayRegistrationId,
      updateSmartWayRegistration,
    ]
  )

  return {
    loading: fetchCarrierProfileLoading || updateSmartWayRegistrationLoading,
    submitHandler,
  }
}
